import { request } from "utils/api";
import { Booking, BookingOptions } from "./bookings";
import { Club } from "./clubs";
import { ReducedUserProfile } from "./user";

// feed item schema
export interface FeedItem {
    booking?: Booking,
    bookingOptionsInfo?: BookingOptions,
    club: Club,
    createdAt: string,
    hasPaymentInfo: boolean,
    paymentInfo?: { priceCents: number },
    story?: Story,
    type: "booking" | "event" | "story",
}

// story schema
interface Story {
    attachedPictureUrl?: string,
    author: ReducedUserProfile,
    authoredAt: string,
    content: string,
    id: string,
}

// fetch dashboard feed (GET /feed/dashboard)
export const getDashboardFeed = (data: {
    clubId: string,
    limit?: number,
    offset?: number,
}) => request<FeedItem[]>({
    data,
    endpoint: "/feed/dashboard",
    method: "get",
});
